<template>
    <div class="container" style="padding-bottom: 30px;">
        <h1 class="title">{{ title }}</h1>

        <div v-if="data != ''" v-for='item in list' class="verItem">
            <label> {{ item.label }} </label>
            <span style="float:right; margin-right: 10px;"> {{ data[item.name] }} </span>
        </div>
    </div>
</template>
  
<script>
import {
    getCustomerReportData,
} from "../../api/userMG";
export default {
    name: "App",
    data() {
        return {
            CID: "",
            UID: "",
            list: [
                {
                    label: '订单:',
                    name: 'UID',
                },
                {
                    label: '车号:',
                    name: "carNo",
                }, {
                    label: '产品:',
                    name: "Goods",
                }, {
                    label: '发货单位:',
                    name: "send",
                }, {
                    label: '收货单位:',
                    name: "receive",
                }, {
                    label: '皮重:',
                    name: "gross",
                }, {
                    label: '毛重:',
                    name: "tare",
                }, {
                    label: '净重:',
                    name: "net",
                }, {
                    label: '入场:',
                    name: "time1",
                }, {
                    label: '出场:',
                    name: "time2",
                }, {
                    label: '备用1:',
                    name: "remark1",
                }, {
                    label: '备用2:',
                    name: "remark2",
                }],
            data: [],
            title: "",
        };
    },
    mounted() {
        document.title = titlePublic;
        if (this.$route.query.CID && this.$route.query.UID) {
            this.CID = this.$route.query.CID;
            this.UID = this.$route.query.UID;
            this.title = titlePublic;
            this.init();
        }
    },
    methods: {
        init() {
            let that = this;
            let params = {
                CID: this.CID,
                UID: this.UID,
            };
            // 校验手机号
            getCustomerReportData(params).then((res) => {
                if (res.data.code == 100) {
                    let data = res.data.data[0];
                    that.data = data;
                }
            });
        }
    },
};
</script>
  
<style scoped lang="less">
.title {
    text-align: center;
    padding: 20px 0;
}

.verItem {
    width: 80%;
    border-bottom: 1px solid gray;
    padding: 16px 10px;
    margin: 0 auto;

    label {
        font-size: 18px;
    }

    span {
        font-size: 18px;
    }
}

.container {
    width: 100%;
    position: absolute;
    z-index: -9999;
}
</style>
  


// WEBPACK FOOTER //
// src/views/outReport/outReport.vue